import { loadStripe } from '@stripe/stripe-js';
import Key from '../clientVariables.json';

let stripePromise;

/**
 * Publishable key only (safe in browser). Set REACT_APP_STRIPE_PUBLISHABLE_KEY or clientVariables.stripePublishableKey.
 */
export function getStripePublishableKey() {
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || Key.stripePublishableKey || '';
}

export function getStripe() {
  const pk = getStripePublishableKey();
  if (!pk) return null;
  if (!stripePromise) {
    stripePromise = loadStripe(pk);
  }
  return stripePromise;
}
